export default "__VITE_PUBLIC_ASSET__6f6527a7__"